module.exports = __webpack_public_path__ + "img/url.bf01f3e7.svg";